module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABAElEQVQ4T53SPSvGYRTH8c/xFpRkkgGLl0EGC8loslmVmUHZ7AalTCYPiwkDmayUvAGyGDwkHV3633f/+8FNru3qXN/re86vE/554i9cZg7gEPdYjIjPX8HM7Mcy1irJAeZ6gpk5hFNc4AGrFbz3I5iZgzjHaPV4B09YwXFXsGZqQI0odnGHrQ6wi6meX2l5MiJeW8AepgKXtqcj4q1cmuAvprMKem/ov8HMHMZJLYh6ey2mdnAB6xhrW4gOUxPMzBHcYh6bGK+KXU11cAnb+EAxb+ARUxHRnKl9NSMzjzBTFUpis7iMiOdee1zAF/ThGmWmAt9ExH5mTlRdtP9x9QXMm16x64UI9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/edit.png
// module id = CuzS
// module chunks = 2